module.exports = __webpack_public_path__ + "static/img/right-home-row-5.79ec2738.png";